export default __webpack_public_path__ + "static/media/awal-mula-hoaks-mobile.21be5eb2.png";